<template>
    <v-btn-toggle 
        v-model="text"
        class="ml-4"
    >
        <v-btn
            value="table"
            class="toggle-btn"
            :class="[text === 'table' ? 'toggle-btn-active' : '']"
            @click="toggleMap('table')"
        >
            <v-icon
                :class="[
                    text === 'table'
                        ? 'toggle-icon-active'
                        : 'toggle-icon-inactive',
                ]"
            >
                mdi-table-column
            </v-icon>
        </v-btn>

        <v-btn
            value="map"
            class="toggle-btn"
            :class="[text === 'map' ? 'toggle-btn-active' : '']"
            @click="toggleMap('map')"
        >
            <v-icon
                :class="[
                    text === 'map' ? 'toggle-icon-active' : 'toggle-icon-inactive',
                ]"
            >
                mdi-map
            </v-icon>
        </v-btn>
    </v-btn-toggle>
</template>
<script>

export default {    
    data: () => ({
        text: 'table',        
    }),
    mounted: function() {
        this.text = this.$route.path.includes('map') ? 'map' : 'table';
    },  
    methods: { 
        toggleMap: function(e) {            
            this.text = e;
            this.$router.push({ path: (e ==='table'? '/tickets': '/map' )});
        },
    },
};

</script>
<style scoped>

</style>